import React from "react";
import ReactDOM from "react-dom/client";
import styles from "./index.module.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";
import RootLayout from "./hoc/RootLayout";
import { initializeRuntimeConfig } from "./config/runtimeConfig";
import "../src/styles/global.scss";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const isPrerender =
  typeof window !== "undefined" &&
  window.location.search.includes("__prerender=1");

const isSWEnabled = process.env.REACT_APP_ENABLE_SW === "true";

// ✅ Флаг для защиты от двойного попапа
let isUpdateHandled = false;

initializeRuntimeConfig().then(() => {
  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <RootLayout>
          <div className={styles.body}>
            <App />
          </div>
        </RootLayout>
      </BrowserRouter>
    </Provider>,
  );

  if (!isPrerender && isSWEnabled) {
    serviceWorkerRegistration.register({
      onUpdate: (registration) => {
        // ✅ Защита от двойного попапа
        if (isUpdateHandled) return;
        isUpdateHandled = true;

        if (window.confirm("Доступна новая версия приложения. Обновить?")) {
          if (registration.waiting) {
            registration.waiting.postMessage({ type: "SKIP_WAITING" });
          }
          window.location.reload();
        }

        // Сброс через 5 секунд
        setTimeout(() => {
          isUpdateHandled = false;
        }, 5000);
      },
      onSuccess: () => {
        console.log("✅ Service Worker зарегистрирован");
      },
    });
  } else if (!isSWEnabled) {
    console.log("⏭️ Service Worker отключен (REACT_APP_ENABLE_SW=false)");
  }
});
